<div>
    <div *ngIf="!isEditable">
        <app-collapse-button [isActive]="!isEditable" (click)='collapse()'></app-collapse-button>
        <app-reload-button-sm [isActive]="!isEditable && !isLoading" (click)="reload()"></app-reload-button-sm>
        <div (click)='collapse()' class='group-title' style='cursor: pointer;'>
            Course Details
        </div>
    </div>
    
    <div [ngClass]='{"hidden" : !display}'>
    
        <app-loading [isLoading]="true" *ngIf="isLoading || isLoadingCache"></app-loading>
        
        <div class="row" *ngIf="!isLoading && !isLoadingCache">
            <form [formGroup]="form" (ngSubmit)="save()" novalidate>

                <div class="col-sm-12" *ngIf="isEditable">
                    <label [ngStyle]="{'padding-top': isEditable ? 0 : null}">
                        Name *
                        <span *ngIf="name.invalid && (name.dirty || name.touched || submitted)" class="error">
                            <span *ngIf="name.errors.required">- Required</span>
                            <span *ngIf="name.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details'>Maxlength: 300 characters</div>
                    </label>
                    <input id="name" formControlName="name" placeholder="Name" required class="form-control" maxlength="300">
                </div>

                <div class="col-sm-12">
                    <label>
                        Description *
                        <span *ngIf="isEditable && description.invalid && (description.dirty || description.touched || submitted)" class="error">
                            <span *ngIf="description.errors.required">- Required</span>
                            <span *ngIf="description.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details' *ngIf="isEditable">Maxlength: 8,000 characters</div>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="!course.description">-</div>
                        <div *ngIf="course.description" [innerHTML]="course.description"></div>
                    </div>
                    <div *ngIf="isEditable">
                        <textarea id="description" formControlName="description" placeholder="Description" rows="10" class="form-control" maxlength="8000"></textarea>
                    </div>
                </div> 
                
                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Region *
                        <span *ngIf="isEditable && region.invalid && (region.dirty || region.touched || submitted)" class="error">
                            <span *ngIf="region.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.region && course.region.displayName?course.region.displayName:"-"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="region" formControlName="region" [items]="regionsScoped" bindValue="id" bindLabel="displayName" placeholder="Select Region" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Budget Discipline
                        <span *ngIf="isEditable && budgetDiscipline.invalid && (budgetDiscipline.dirty || budgetDiscipline.touched || submitted)" class="error">
                            <span *ngIf="budgetDiscipline.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.budgetDiscipline && course.budgetDiscipline.name?course.budgetDiscipline.name:"-"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="budgetDiscipline" formControlName="budgetDiscipline" [items]="budgetDisciplines" bindValue="id" bindLabel="name" placeholder="Select Budget Discipline" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Status *
                        <span *ngIf="isEditable && status.invalid && (status.dirty || status.touched || submitted)" class="error">
                            <span *ngIf="status.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.status && course.status.name?course.status.name:"-"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="status" formControlName="status" [items]="statuses" bindValue="id" bindLabel="name" placeholder="Select Status" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Structure *
                        <span *ngIf="isEditable && structure.invalid && (structure.dirty || structure.touched || submitted)" class="error">
                            <span *ngIf="structure.errors.required">- Required</span>
                        </span>
                        <app-display-box>
                            The structure field represents how the instruction is "organized", and can have the following values:
                            <ul>
                                <li>Asychronous Series: Multiple online modules, frequently with requirement for being taken together and/or in sequence.</li>
                                <li>Asychronous Workshop: Stand-alone online training module.</li>
                                <li>Blended Learning: Traditional classroom workshop with mandatory supplemental or prerequisite on-line components.</li>
                                <li>Conference: Traditional meeting with multiple, frequently concurrent, sessions concentrated over a few days</li>
                                <li>Practice-Based Education: Training integrated in health professional practice setting.</li>
                                <li>Series: Traditional classroom offering of multiple sessions distributed over extended period up to a year. (Ex.Grand Rounds)</li>
                                <li>Workshop: Traditional classroom-based education typically offered on a single day and with no concurrent sessions.</li>
                            </ul>
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">{{course.structure && course.structure.name?course.structure.name:"-"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="structure" formControlName="structure" [items]="structures" bindValue="id" bindLabel="name" placeholder="Select Structure" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Calendar Scope *
                        <span *ngIf="isEditable && calendarScope.invalid && (calendarScope.dirty || calendarScope.touched || submitted)" class="error">
                            <span *ngIf="calendarScope.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.calendarScope && course.calendarScope.name?course.calendarScope.name:"-"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="calendarScope" formControlName="calendarScope" [items]="calendarScopes" bindValue="id" bindLabel="name" placeholder="Select Calendar Scope" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Start Date *
                        <span *ngIf="startDate.invalid && (startDate.dirty || startDate.touched || submitted)" class="error">
                            <span *ngIf="startDate.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.startDate?course.startDate:"-"}}</div>
                    <div *ngIf="isEditable">
                        <div id="startDate" formControlName="startDate" class="input-group" a2e-datetimepicker [options]="a2eOptions">
                            <input class="form-control"/>
                            <span class="input-group-addon">
                                <!-- <span class="glyphicon glyphicon-calendar"></span> -->
                                <i class="fa fa-calendar"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        End Date
                    </label>
                    <div *ngIf="!isEditable">{{course.endDate?course.endDate:"-"}}</div>
                    <div *ngIf="isEditable">
                        <div id="endDate" formControlName="endDate" class="input-group" a2e-datetimepicker [options]="a2eOptions">
                            <input class="form-control" />
                            <span class="input-group-addon">
                                <!-- <span class="glyphicon glyphicon-calendar"></span> -->
                                <i class="fa fa-calendar"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        OLR Ready *
                        <span *ngIf="olrReady.invalid && (olrReady.dirty || olrReady.touched || submitted)" class="error">
                            <span *ngIf="olrReady.errors.required">- Required</span>
                        </span>
                        <app-display-box>
                            The OLR Ready field is being used to identify those Events that are ready to appear in the OnLine Registration (OLR) web applications developed and maintained by regional AHEC IT staff. New Events, by default, are set to "No".
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">{{course.olrReady ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="olrReady" formControlName="olrReady" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select OLR Ready" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        OLC Ready *
                        <span *ngIf="olcReady.invalid && (olcReady.dirty || olcReady.touched || submitted)" class="error">
                            <span *ngIf="olcReady.errors.required">- Required</span>
                        </span>
                        <app-display-box>
                            The OLC Ready field is being used to identify those Events that are ready for the automated OnLine Certificate (OLC) function, which is available after online evaluation/assessment -- a feature new in 2012 developed by Greensboro AHEC for those regional AHECs for whom they support an on-line registration portal. New Events, by default, are set to "No".
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">{{course.olcReady ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="olcReady" formControlName="olcReady" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select OLC Ready" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Use Advanced OLR *
                        <span *ngIf="useAdvancedOlr.invalid && (useAdvancedOlr.dirty || useAdvancedOlr.touched || submitted)" class="error">
                            <span *ngIf="useAdvancedOlr.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.useAdvancedOlr ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="useAdvancedOlr" formControlName="useAdvancedOlr" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Use Advanced OLR" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Max Attendance Estimate *
                        <span *ngIf="attendEstimate.invalid && (attendEstimate.dirty || attendEstimate.touched || submitted)"
                            class="error">
                            <span *ngIf="attendEstimate.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.attendEstimate?course.attendEstimate:"-"}}</div>
                    <div *ngIf="isEditable">
                        <input id="attendEstimate" formControlName="attendEstimate" class="form-control" type="number" min = "0" placeholder="Max Attendance Estimate" required>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Reporting Contact Hours *
                        <span *ngIf="reportingContactHours.invalid && (reportingContactHours.dirty || reportingContactHours.touched || submitted)"
                            class="error">
                            <span *ngIf="reportingContactHours.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.reportingContactHours?course.reportingContactHours:"-"}}</div>
                    <div *ngIf="isEditable">
                        <input id="reportingContactHours" formControlName="reportingContactHours" class="form-control" type="number" min = "0" placeholder="Reporting Contact Hours" required>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Report Exclusion *
                        <span *ngIf="reportingExclusion.invalid && (reportingExclusion.dirty || reportingExclusion.touched || submitted)" class="error">
                            <span *ngIf="reportingExclusion.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.reportingExclusion ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="reportingExclusion" formControlName="reportingExclusion" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Report Exclusion" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        ACCME Activity ID
                        <span *ngIf="accmeActivityID.invalid && (accmeActivityID.dirty || accmeActivityID.touched || submitted)"
                            class="error">
                            <!-- <span *ngIf="accmeActivityID.errors.required">- Required</span> -->
                        </span>
                        <app-display-box>
                            The unique ID generated when you create the event in ACCME web portal for PARS reporting.
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">{{course.accmeActivityID?course.accmeActivityID:"-"}}</div>
                    <div *ngIf="isEditable">
                        <input id="accmeActivityID" formControlName="accmeActivityID" class="form-control" type="any" placeholder="ACCME Activity ID">
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Suppress on CPD Records *
                        <span *ngIf="suppressCPDRecord.invalid && (suppressCPDRecord.dirty || suppressCPDRecord.touched || submitted)" class="error">
                            <span *ngIf="suppressCPDRecord.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.suppressCPDRecord ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="suppressCPDRecord" formControlName="suppressCPDRecord" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Suppress on CPD Records" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Contact Person (CASCE Person PK)
                    </label>
                    <div *ngIf="!isEditable && course.contactPerson.id">{{course.contactPerson.firstname}} {{course.contactPerson.lastname}} ({{course.contactPerson.id}})</div>
                    <div *ngIf="!isEditable && !course.contactPerson.id">-</div>
                    <div *ngIf="isEditable">
                        <input id="contactPerson" formControlName="contactPerson" class="form-control" type="number" min = "0" placeholder="CASCE Person PK">
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Contact Phone
                    </label>
                    <div *ngIf="!isEditable">{{course.contactPhone?course.contactPhone:"-"}}</div>
                    <div *ngIf="isEditable">
                        <input id="contactPhone" formControlName="contactPhone" class="form-control" placeholder="Contact Phone">
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Brochure URL
                        <span *ngIf="brochureUrl.invalid && (brochureUrl.dirty || brochureUrl.touched || submitted)" class="error">
                            <span *ngIf="brochureUrl.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details' *ngIf="isEditable">Maxlength: 100 characters</div>
                    </label>
                    <div *ngIf="!isEditable">{{course.brochureUrl?course.brochureUrl:"-"}}</div>
                    <div *ngIf="isEditable">
                        <input id="brochureUrl" formControlName="brochureUrl" class="form-control" placeholder="Brochure URL" maxlength='100'>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Internal Comments
                        <span *ngIf="internalComment.invalid && (internalComment.dirty || internalComment.touched || submitted)" class="error">
                            <span *ngIf="internalComment.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details' *ngIf="isEditable">Maxlength: 2,000 characters</div>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="!course.internalComment">-</div>
                        <div *ngIf="course.internalComment" [innerHTML]="course.internalComment"></div>
                    </div>
                    <div *ngIf="isEditable">
                        <textarea id="internalComment" formControlName="internalComment" class="form-control" placeholder="Internal Comment" maxlength='2000' rows="10"></textarea>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Purpose Goals
                        <span *ngIf="purposeGoals.invalid && (purposeGoals.dirty || purposeGoals.touched || submitted)" class="error">
                            <span *ngIf="purposeGoals.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details' *ngIf="isEditable">Maxlength: 500 characters</div>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="!course.purposeGoals">-</div>
                        <div *ngIf="course.purposeGoals" [innerHTML]="course.purposeGoals"></div>
                    </div>
                    <div *ngIf="isEditable">
                        <textarea id="purposeGoals" formControlName="purposeGoals" class="form-control" placeholder="Purpose Goals" maxlength='500' rows="10"></textarea>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Topic Keywords
                        <span *ngIf="topicKeywords.invalid && (topicKeywords.dirty || topicKeywords.touched || submitted)" class="error">
                            <span *ngIf="topicKeywords.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details' *ngIf="isEditable">Maxlength: 300 characters</div>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="!course.topicKeywords">-</div>
                        <div *ngIf="course.topicKeywords" [innerHTML]="course.topicKeywords"></div>
                    </div>
                    <div *ngIf="isEditable">
                        <textarea id="topicKeywords" formControlName="topicKeywords" class="form-control" placeholder="Topic Keywords" maxlength='300' rows="10"></textarea>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Audience
                        <span *ngIf="targetAudience.invalid && (targetAudience.dirty || targetAudience.touched || submitted)" class="error">
                            <span *ngIf="targetAudience.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details' *ngIf="isEditable">Maxlength: 500 characters</div>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="!course.targetAudience">-</div>
                        <div *ngIf="course.targetAudience" [innerHTML]="course.targetAudience"></div>
                    </div>
                    <div *ngIf="isEditable">
                        <textarea id="targetAudience" formControlName="targetAudience" class="form-control" placeholder="Audience" maxlength='500' rows="10"></textarea>
                    </div>
                </div>

                <div class="col-sm-12">
                    <div class='group-title' style='margin-top:2.0em;'>
                        Registration (beta)
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Activate Registration
                        <span *ngIf="registration.invalid && (registration.dirty || registration.touched || submitted)"
                            class="error">
                            <span *ngIf="registration.errors.required">- Required</span>
                        </span>
                        <app-display-box>
                            The Activate Registration field directs Registration for this Event to the NC AHEC Web Services Registration application.
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">{{course.registration ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="registration" formControlName="registration" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Activate Registration" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Email Calendar Reminder
                         <!-- *
                        <span *ngIf="calendarReminder.invalid && (calendarReminder.dirty || calendarReminder.touched || submitted)" class="error">
                            <span *ngIf="calendarReminder.errors.required">- Required</span>
                        </span> -->
                        <app-display-box>
                            The Email Calendar Reminder field will include a Calendar Reminder attachment to the Registration confirmation email sent to the registering User. 
                            Selecting Event will use the Event Start Date and Event End Date.
                            <!-- Selecting Session Attendance will use the Session Start Date and Session End Date for each Session the User has elected to attend. -->
                            <b>Reminders will not be sent for Courses with Asynchronous Structures.</b>
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">{{calendarReminderName != null ? calendarReminderName : "-"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="calendarReminder" formControlName="calendarReminder" [items]="calendarReminderOptions" bindValue="value" bindLabel="name" placeholder="Select Calendar Reminder" [clearable]="true" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12">
                    <div class='group-title' style='margin-top:2.0em;'>
                        Catalog
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Image
                        <span *ngIf="image.invalid && (image.dirty || image.touched || submitted)" class="error">
                            <span *ngIf="image.errors.requiredFileCatalogImageDetails">- Please select a Region and Budget Discipline</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="!course.image">-</div>
                        <div *ngIf="course.image">
                            <img src="{{course.image.small}}" />
                        </div>
                    </div>
                    <div *ngIf="isEditable">
                        <div class="form-group">
                            <app-file-select [id]="'image'" formControlName="image"></app-file-select>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Region Tags
                        <app-display-box>
                            Selecting Region Tags will add this event to the course catalog listing for other AHECs. This field is only to be used if the event is co-sponsored by another AHEC.
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="course.tagRegions.length === 0">-</div>
                        <div *ngIf="course.tagRegions.length > 0">
                            <div *ngFor="let region of course.tagRegions" style='margin-bottom:0.25em;'>
                                {{region.displayName}}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isEditable">
                        <ng-select id="tagRegions" formControlName="tagRegions" [items]="regions" bindValue="id" bindLabel="displayName" placeholder="Select Regional Tags" [clearable]="false" [searchable]="false" [multiple]="true"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Statewide Tags
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="course.tagStatewide.length === 0">-</div>
                        <div *ngIf="course.tagStatewide.length > 0">
                            <div *ngFor="let statetag of course.tagStatewide" style='margin-bottom:0.25em;'>
                                {{statetag.name}}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isEditable">
                        <ng-select id="tagStatewide" formControlName="tagStatewide" [items]="tagsStatewide" bindValue="id" bindLabel="name" placeholder="Select Statewide Tags" [clearable]="false" [searchable]="false" [multiple]="true"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12">
                    <div class="group-title" style='margin-top:2.0em;'>Landing Page</div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Status *
                        <span *ngIf="isEditable && landingPage.invalid && (landingPage.dirty || landingPage.touched || submitted)" class="error">
                            <span *ngIf="landingPage.errors.required">- Required</span>
                        </span>
                        <!-- <div class='details' *ngIf="isEditable"></div> -->
                    </label>
                    <div *ngIf="!isEditable">
                        <div>{{course.landingPage ? "Yes" : "No"}}</div>
                        <div style='margin-top:1.0em;'>
                            <app-open-button-sm (click)='open(course.landingPageUrl)' [ngClass]="{'hide':isEditable}">View Landing Page Preview <span *ngIf="!course.landingPage">(Inactive)</span></app-open-button-sm>
                        </div>
                    </div>
                    <div *ngIf="isEditable">
                        <ng-select id="landingPage" formControlName="landingPage" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Landing Page Status" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Image
                        <span *ngIf="image.invalid && (image.dirty || image.touched || submitted)" class="error">
                            <span *ngIf="image.errors.requiredFileCatalogImageDetails">- Please select a Region and Budget Discipline</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="!course.landingPageImage">-</div>
                        <div *ngIf="course.landingPageImage">
                            <img src="{{course.landingPageImage.small}}" />
                        </div>
                    </div>
                    <div *ngIf="isEditable">
                        <div class="form-group">
                            <app-file-select [id]="'landingPageImage'" formControlName="landingPageImage"></app-file-select>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Welcome Message
                        <span *ngIf="isEditable && welcomeMessage.invalid && (welcomeMessage.dirty || welcomeMessage.touched || submitted)" class="error">
                            <span *ngIf="welcomeMessage.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details' *ngIf="isEditable">Maxlength: 4,000 characters</div>
                    </label>
                    <div *ngIf="!isEditable">
                        <div *ngIf="course.welcomeMessage" [innerHTML]="course.welcomeMessage"></div>
                        <div *ngIf="!course.welcomeMessage">-</div>
                    </div>
                    <div *ngIf="isEditable">
                        <textarea id="welcomeMessage" formControlName="welcomeMessage" placeholder="Welcome Message" rows="10" class="form-control" maxlength="2000"></textarea>
                    </div>
                </div>
                
                <div class="col-sm-12">
                    <label>
                        Custom Join Link URL
                        <span *ngIf="isEditable && joinUrl.invalid && (joinUrl.dirty || joinUrl.touched || isSubmitted)" class="error">
                            <span *ngIf="joinUrl.errors.maxlength">- Too long</span>
                        </span>
                        <div class='details' *ngIf="isEditable">Maxlength: 400 characters</div>
                    </label>
                    <div *ngIf="!isEditable">
                        <div class='pull-right' style='margin-left:0.5em;' *ngIf="course.joinUrl">
                            <app-open-button-sm (click)="open(course.joinUrl)">Join</app-open-button-sm>
                        </div>
                        {{course.joinUrl?course.joinUrl:"-"}}
                    </div>
                    <div *ngIf="isEditable">
                        <input id="joinUrl" formControlName="joinUrl" class="form-control" placeholder="URL" maxlength='400'>
                    </div>
                </div>
                
                <!-- 
                <div class="col-sm-12">
                    <div class='group-title' style='margin-top:2.0em;'>
                        Learning Management System
                    </div>
                </div>
                
                <div class="col-sm-12">
                    <label>
                        Show Open Button
                    </label>
                    <div *ngIf="!isEditable">{{course.showLmsOpen ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="showLmsOpen" formControlName="showLmsOpen" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Show Open Button" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>
                -->
                 
                <!-- .tags(ng-if='isEditable')
                  .col-xs-12.tags-display
                    h6 Tags
                  .col-xs-12.form-group
                    label Region
                    div
                      ol#values-example.nya-bs-select(name='ahec_id' ng-model="course.tags.regions" multiple data-selected-text-format="count > 1" title="Select")
                        li(nya-bs-option="option in regions" data-value="option.region_id.toString()")
                          a {{option.region_id | ahecIdtoRegionName:regions}}
                            span.glyphicon.glyphicon-ok.check-mark
                
                .lms(ng-if='isEditable')
                  .col-xs-12.tags-display
                    h6 Learning Management System
                  
                  .col-xs-12.form-group
                    label Show Open Button *
                      span(ng-messages="parent.show_lms_open.$error" ng-if="parent.show_lms_open.$dirty" role="alert")
                        span.error(ng-message="required") - required

                    div
                      ol#values-example.nya-bs-select(name='show_lms_open' ng-model="course.show_lms_open" ng-required="true" title="Select")
                        li(nya-bs-option="option in [{show_lms_open:true,name:'Yes'},{show_lms_open:false,name:'No'}]" data-value="option.show_lms_open")
                          a {{option.name}}
                            span.glyphicon.glyphicon-ok.check-mark
                -->



                <!-- 
                *ngIf="isAdvancedEdit"

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Track Selection Required *
                        <span
                            *ngIf="reportingContactHours.invalid && (trackSelectionRequired.dirty || trackSelectionRequired.touched || submitted)"
                            class="error">
                            <span *ngIf="trackSelectionRequired.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.trackSelectionRequired ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="trackSelectionRequired" formControlName="trackSelectionRequired" [items]="yesNo"
                            bindValue="value" bindLabel="name" placeholder="Select Track Selection Required" [clearable]="false"
                            [searchable]="false"></ng-select>
                    </div>
                </div>
                
                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Reporting Headcount *
                        <span *ngIf="reportingHeadcount.invalid && (reportingHeadcount.dirty || reportingHeadcount.touched || submitted)"
                            class="error">
                            <span *ngIf="reportingHeadcount.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.reportingHeadcount?course.reportingHeadcount:"-"}}</div>
                    <div *ngIf="isEditable">
                        <input id="reportingHeadcount" formControlName="reportingHeadcount" class="form-control" type="number" min = "0" placeholder="Reporting Head Count" required>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        CIPE Event *
                        <span *ngIf="cipeEvent.invalid && (cipeEvent.dirty || cipeEvent.touched || submitted)" class="error">
                            <span *ngIf="cipeEvent.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.cipeEvent ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="cipeEvent" formControlName="cipeEvent" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select CIPE Event" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Multi AHEC Event *
                        <span *ngIf="multiAhecEvent.invalid && (multiAhecEvent.dirty || multiAhecEvent.touched || submitted)" class="error">
                            <span *ngIf="multiAhecEvent.errors.required">- Required</span>
                        </span>
                    </label>
                    <div *ngIf="!isEditable">{{course.multiAhecEvent ? "Yes" : "No"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="multiAhecEvent" formControlName="multiAhecEvent" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Multi AHEC Event" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        Reporting Crosstab Header *
                        <span *ngIf="reportingCrosstabHeader.invalid && (reportingCrosstabHeader.dirty || reportingCrosstabHeader.touched || submitted)" class="error">
                            <span *ngIf="reportingCrosstabHeader.errors.required">- Required</span>
                        </span>
                        <app-display-box>
                            <div>The Reporting Crosstab Header is used to tag the event as one of usually, several offerings of the same course for which attendance is tracked via Multi-Event Attendance Crosstab Web Query, typically for purposes of reporting to contracted organizations on the progress of their employees. Due to the summary nature of aggregating what amounts to date-of-attendance report headers, these values are limited to 10 characters and should contain no spaces.</div>
                            <div style="margin-top:1.0em;">Please Note: The web query mentioned above does not limit by region such that common headers, shared among regional AHECs, can be used to report together in support of system-wide collaboration toward the goals of tracking all related education offerings, regardless of sponsor.</div>
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">{{course.reportingCrosstabHeader ? course.reportingCrosstabHeader : "-"}}</div>
                    <div *ngIf="isEditable">
                        <input id="reportingCrosstabHeader" formControlName="reportingCrosstabHeader" class="form-control" placeholder="Reporting Crosstab Header" required>
                    </div>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-3">
                    <label>
                        PARS Sponsorship *
                        <span *ngIf="parsSponsorship.invalid && (parsSponsorship.dirty || parsSponsorship.touched || submitted)" class="error">
                            <span *ngIf="parsSponsorship.errors.required">- Required</span>
                        </span>
                        <app-display-box>
                            The PARS Sponsorship field is explicitly required by ACCME's <a href="http://www.accme.org/cme-providers/maintaining-your-accreditation/about-pars">Program and Activity Reporting System (PARS)</a> to indicate whether the event had "Direct" or "Joint" sponsorship.  It is included among other fields in CASCE when an Excel file is generated, suitable for uploading into PARS. As such, this setting is only relevant for Events that offer CME credit, so can be ignored for others and left with the "Direct" default value.
                        </app-display-box>
                    </label>
                    <div *ngIf="!isEditable">{{course.parsSponsorship?course.parsSponsorship:"-"}}</div>
                    <div *ngIf="isEditable">
                        <ng-select id="parsSponsorship" formControlName="parsSponsorship" [items]="['Direct','Joint']" bindValue="value" bindLabel="value" placeholder="Select PARS Sponsorship" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>

                .brochure_sponsorship_statement(ng-if='isEditable && isAdvanced')
                  .col-xs-12.form-group
                    label Brochure Sponsorship Statement (max 700 chars)
                      span(ng-messages="parent.brochure_sponsorship_statement.$error" ng-if="parent.brochure_sponsorship_statement.$dirty" role="alert")
                        span.error(ng-message="maxlength") - 700 characters maximum
                    div
                      textarea.form-control(name='brochure_sponsorship_statement' ng-model="course.brochure_sponsorship_statement" placeholder="Brochure sponsorship statement" ng-maxlength="700" rows="10")

                .addl_revenue_description(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Additional Revenue Description
                    div
                      input.form-control(name='addl_revenue_description' type="text" ng-model="course.addl_revenue_description" placeholder="Additional revenue description")

                .addl_revenue_amount(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Additional Revenue Amount
                    div
                      input.form-control(name='addl_revenue_amount' type="number" min = "0" ng-model="course.addl_revenue_amount" placeholder="Additional revenue description, ex. 0.00")

                .vendor_revenue_description(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Vendor Revenue Description
                    div
                      input.form-control(name='vendor_revenue_description' type="text" ng-model="course.vendor_revenue_description" placeholder="Vendor revenue description")

                .vendor_revenue_amount(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Vendor Revenue Amount
                    div
                      input.form-control(name='vendor_revenue_amount' type="number" min = "0" ng-model="course.vendor_revenue_amount" placeholder="Vendor revenue amount, ex. 0.00")

                .meals_cost(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Meals Cost
                    div
                      input.form-control(name='meals_cost' type="number" min = "0" ng-model="course.meals_cost" placeholder="Meals cost, ex. 0.00")

                .breaks_cost(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Breaks Cost
                    div
                      input.form-control(name='breaks_cost' type="number" min = "0" ng-model="course.breaks_cost" placeholder="Breaks cost, ex. 0.00")

                .misc_food_description(ng-if='isEditable && isAdvanced')
                  .col-xs-12.form-group
                    label Misc Food Description (max 500 chars)
                      span(ng-messages="parent.misc_food_description.$error" ng-if="parent.misc_food_description.$dirty" role="alert")
                        span.error(ng-message="maxlength") - 500 characters maximum
                    div
                      textarea.form-control(name='misc_food_description' ng-model="course.misc_food_description" placeholder="Misc food description" ng-maxlength="500" rows="10")

                .misc_food_cost(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Misc Food Cost
                    div
                      input.form-control(name='misc_food_cost' type="number" min = "0" ng-model="course.misc_food_cost" placeholder="misc food cost, ex. 0.00")

                .brochure_count(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Brochure Count
                    div
                      input.form-control(name='brochure_count' type="number" min = "0" ng-model="course.brochure_count" placeholder="Brochure count")

                .brochure_mail(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Brochure Mail
                    div
                      input.form-control(name='brochure_mail' type="number" min = "0" ng-model="course.brochure_mail" placeholder="Brochure mail, ex. 0.00")

                .brochure_presort(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Brochure Presort
                    div
                      input.form-control(name='brochure_presort' type="number" min = "0" ng-model="course.brochure_presort" placeholder="Brochure presort, ex. 0.00")

                .brochure_print_total(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Brochure Print Total
                    div
                      input.form-control(name='brochure_print_total' type="number" min = "0" ng-model="course.brochure_print_total" placeholder="Brochure print total, ex. 0.00")

                .brochure_misc_description(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Brochure Misc Description
                    div
                      input.form-control(name='brochure_misc_description' type="text" ng-model="course.brochure_misc_description" placeholder="Brochure misc description")

                .brochure_misc_amount(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Brochure Misc Amount
                    div
                      input.form-control(name='brochure_misc_amount' type="number" min = "0" ng-model="course.brochure_misc_amount" placeholder="Brochure misc amount, ex. 0.00")

                .facility_rental(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Facility Rental
                    div
                      input.form-control(name='facility_rental' type="number" min = "0" ng-model="course.facility_rental" placeholder="Facility rental, ex. 0.00")

                .facility_rental_per_attend(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Facility Rental Per Attend
                    div
                      input.form-control(name='facility_rental_per_attend' type="number" min = "0" ng-model="course.facility_rental_per_attend" placeholder="Facility rental per attend, ex. 0.00")

                .honoraria_description(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Honoraria Description
                    div
                      input.form-control(name='honoraria_description' type="text" ng-model="course.honoraria_description" placeholder="Honoraria description")

                .honoraria_amount(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Honoraria Amount
                    div
                      input.form-control(name='honoraria_amount' type="number" min = "0" ng-model="course.honoraria_amount" placeholder="Honoraria amount, ex. 0.00")

                .travel_guests(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Travel Guests
                    div
                      input.form-control(name='travel_guests' type="number" min = "0" ng-model="course.travel_guests" placeholder="Travel guests, ex. 0.00")

                .pay_support_staff(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Pay Support Staff
                    div
                      input.form-control(name='pay_support_staff' type="number" min = "0" ng-model="course.pay_support_staff" placeholder="Pay support staff, ex. 0.00")

                .pay_prof_staff(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Pay Prof Staff
                    div
                      input.form-control(name='pay_prof_staff' type="number" min = "0" ng-model="course.pay_prof_staff" placeholder="Pay prof staff, ex. 0.00")

                .ceu_credit(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label CEU Credit
                    div
                      input.form-control(name='ceu_credit' type="number" min = "0" ng-model="course.ceu_credit" placeholder="CEU Credit, ex. 0.00")

                .av_description(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label AV Description
                    div
                      input.form-control(name='av_description' type="text" ng-model="course.av_description" placeholder="AV description")

                .av_services(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label AV Services
                    div
                      input.form-control(name='av_services' type="number" min = "0" ng-model="course.av_services" placeholder="AV services, ex. 0.00")

                .supplies_description(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Supplies Description
                    div
                      input.form-control(name='supplies_description' type="text" ng-model="course.supplies_description" placeholder="Supplies description")

                .supplies(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label Supplies
                    div
                      input.form-control(name='supplies' type="number" min = "0" ng-model="course.supplies" placeholder="Supplies, ex. 0.00")

                .eeds_conference_id(ng-if='isEditable && isAdvanced')
                  .col-xs-12.col-sm-6.col-md-4.col-lg-3.form-group
                    label EEDS Conference ID
                    div
                      input.form-control(name='eeds_conference_id' type="number" min = "0" ng-model="course.eeds_conference_id" placeholder="EEDS conference id") -->

                <div class="clear"></div>
            </form>

            <!-- <div class="col-sm-12"><pre>{{course | json}}</pre></div> -->
            
        </div>
    </div>
</div>